import { useCallback } from "react";
import {
  ReceivedBseBidDto,
  useEditNegotiationRoundMutation,
  useUpdateBasicSourcingEventMutation,
} from "../../../../../autogen/bff-api";
import { useAppDispatch } from "../../../../../common/redux/hooks";
import {
  removeBid,
  setNegotiationRound,
  setSourcingEvent,
} from "../../../../../common/redux/reducers/basicSourcingEventReducer";
import { ProductGroup } from "../../../../../common/types";

export const useRemoveProductBid = ({
  bid,
  productId,
  group,
  eventId,
  negotiationRoundId,
}: {
  bid: ReceivedBseBidDto;
  productId: string;
  group: ProductGroup;
  eventId: string;
  negotiationRoundId?: string;
}) => {
  const [updateSourcingEvent, { isLoading: isUpdatingEvent }] = useUpdateBasicSourcingEventMutation();
  const [editNegotiationRound, { isLoading: isEditingRound }] = useEditNegotiationRoundMutation();
  const dispatch = useAppDispatch();

  const removeProductBid = useCallback(async () => {
    dispatch(removeBid({ bid, productId, group }));

    if (negotiationRoundId) {
      const round = await editNegotiationRound({
        negotiationId: negotiationRoundId,
        editNegotiationRequest: {
          removeProductBids: [{ productGroupId: group.id, bids: [{ productId, bids: [bid.id] }] }],
        },
      }).unwrap();
      dispatch(setNegotiationRound(round));
    } else {
      const event = await updateSourcingEvent({
        eventId,
        editSourcingEventRequest: {
          removeProductBids: [{ productGroupId: group.id, bids: [{ productId, bids: [bid.id] }] }],
        },
      }).unwrap();
      dispatch(setSourcingEvent(event));
    }
  }, [bid, negotiationRoundId, dispatch, editNegotiationRound, eventId, group, productId, updateSourcingEvent]);

  return { removeProductBid, isLoading: isUpdatingEvent || isEditingRound };
};
